/** @jsxImportSource @emotion/react */
import Close from '@mui/icons-material/Close';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  useTheme,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from '@mui/material';
import LoadingScreen from 'base/ui/components/LoadingScreen/loadingScreen';
import { toJS } from 'mobx';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';
import { CancelConfirmStage } from 'services/historyReceive_sevieces';
import { InfoPallet } from 'services/workOrder_services';
import * as rootStore from 'stores/root_store';

interface PalletDetailProps {
  data: InfoPallet | undefined;
  editLSX: boolean;
}

const columnTable2 = [
  {
    columnName: 'Thứ tự công đoạn',
    align: 'text-center',
    visible: true,
  },
  {
    columnName: 'Công đoạn',
    align: 'text-center',
    visible: true,
  },
  {
    columnName: 'Người XNHT',
    align: 'text-center',
    visible: true,
  },
  {
    columnName: 'Thời gian XNHT',
    align: 'text-center',
    visible: true,
  },
  {
    columnName: 'Người hủy XNHT',
    align: 'text-center',
    visible: true,
  },
  {
    columnName: 'Thời gian hủy XNHT',
    align: 'text-center',
    visible: true,
  },
  {
    columnName: 'Hủy XNHT',
    align: 'text-center',
    visible: true,
  },
];

const Style = {
  MuiTableCellRoot: {
    fontSize: '13px',
    fontWeight: 700,
    padding: '5px 10px',
    lineHeight: '20px',
    color: 'white',
  },
  borderInherit: {
    borderCollapse: 'inherit',
  },
  MuiButtonBaseRoot: {
    color: 'white !important',
  },
  MuiTableCellRootTd: {
    fontSize: '13px',
    padding: '5px 10px',
    lineHeight: '20px',
    borderBottom: 'unset',
  },
  sticky1: {
    position: 'sticky',
    left: 0,
    background: 'white',
    zIndex: 5,
  },
  sticky2: {
    position: 'sticky',
    left: 45.2,
    background: 'white',
    zIndex: 5,
  },
  sticky3: {
    position: 'sticky',
    left: 294.5,
    background: 'white',
    zIndex: 5,
    color: '#0284c7',
  },

  '.MuiOutlinedInput-root': {
    padding: 0,
  },
  '.MuiOutlinedInput-input': {
    fontSize: '13px',
  },
  '.MuiOutlinedInput-notchedOutline': { borderRadius: 0 },
};

function HistoryConfirmStage(props: PalletDetailProps) {
  const { data } = props;
  // lưu workOrderId từ roostore
  const { workOrderId } = useParams();
  // State lưu workOderId và orderIndex
  const [dataCancelConfirmStage, setdataCancelConfirmStage] = useState<CancelConfirmStage>({
    workOrderId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    orderIndex: 0,
  });
  //#####POPUP
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  //#Xử lý modal
  const [open, setOpen] = useState(false);
  // Xử lý khi đóng modal
  const handleClose = async (e: string) => {
    if (e === 'ignore') setOpen(false);
    if (e === 'confirm') {
      setOpen(false);
      await rootStore.historyReceivePresenter.cancelConfirmStage(rootStore.historyReceiveStore, dataCancelConfirmStage);
      if (rootStore.historyReceiveStore.cancelConfirmStage.isSuccess) {
        toast.success(rootStore.historyReceiveStore.cancelConfirmStage.message);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    }
  };
  // // Xử lý mở modal
  const handleOpen = (orderIndex: number) => {
    setOpen(true);
    setdataCancelConfirmStage({
      workOrderId: workOrderId ?? '',
      orderIndex: orderIndex,
    });
  };
  //####END POPUP

  // SetStage disable
  const [isDisable, setIsDisable] = useState<boolean[]>([]);
  // list lưu số đầu
  const [number, setNumber] = useState<number[]>([]);
  // State cho màn hình loding
  // const [loading, setloading] = useState(true);

  useEffect(() => {
    // // lọc mảng và trừ index cuối ra
    // const doneList = data?.historyConfirmStage.filter((item) => item.status === 'DAHOANTHANH');
    // console.log(doneList);

    // let filter = doneList?.pop();

    // let convertNum = (toJS(filter)?.stt ?? 0) / 10;

    // let soDau = Math.floor(convertNum);
    // console.log(soDau);

    // const handleIsDisable = () => {
    //   doneList?.map((item) => {
    //     let number = item.stt / 10;
    //     if (item.status === 'DAHOANTHANH' && number < soDau) isDisable.push(true);
    //   });
    //   setloading(false);
    // };
    // handleIsDisable()

    // Các công đoạn có order index đuôi 5-6-7-8-9: Không cần check điều kiện hủy XNHT, muốn nhấn nút lúc nào cũng được
    // Các công đoạn có order index đuôi 0-1-2 (Ví dụ 10,11,12,20,110,121,...) thì phải check điều kiện khi nhấn nút "Hủy XNHT": Chỉ được nhấn khi công đoạn tiếp theo sau nó chưa XNHT.
    //  Ví dụ: Nếu công đoạn 60 isXNHT=true thì công đoạn 50 không được nhấn nút hủy XNHT

    let listDisabled: boolean[] = [];
    const endItem = data?.historyConfirmStage
      .filter(
        (item) =>
          item.status === 'DAHOANTHANH' &&
          (item.stt.toString().endsWith('0') || item.stt.toString().endsWith('1') || item.stt.toString().endsWith('2')),
      )
      .pop();

    data?.historyConfirmStage.forEach((item, index) => {
      if (item.stt.toString().endsWith('0') || item.stt.toString().endsWith('1') || item.stt.toString().endsWith('2')) {
        if (item.stt === endItem?.stt) {
          listDisabled.push(false);
        } else listDisabled.push(true);
      } else {
        listDisabled.push(false);
      }
    });
    setIsDisable(listDisabled);
  }, [data]);
  return (
    <>
      {/* LỊCH SỬ XÁC NHẬN HOÀN THÀNH CÔNG ĐOẠN */}

      <div>
        <h3 className="font-medium">LỊCH SỬ XÁC NHẬN HOÀN THÀNH CÔNG ĐOẠN :</h3>
        <div className={`overflow-x-auto mt-2`}>
          <TableContainer
            component={Paper}
            className="w-full table-auto overflow-y-hidden space-collapse mb-5 text-default"
          >
            <Table aria-label="simple table" sx={Style.borderInherit}>
              <TableHead className="font-medium text-gray-700 text-default bg-gray-100">
                <TableRow>
                  {columnTable2?.map((item, index) => {
                    if (item.visible) {
                      return (
                        <TableCell
                          sx={[Style.MuiTableCellRoot]}
                          key={index}
                          scope="col"
                          className={`${item.visible ? '' : 'hidden'} py-2 px-2 border !text-left bg-primary ${
                            item.align
                          }`}
                          align={`${item.align === 'text-center' ? 'center' : 'inherit'}`}
                        >
                          {item.columnName}
                        </TableCell>
                      );
                    }
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.historyConfirmStage.map((row, index: number): any => (
                  <TableRow key={index}>
                    {/* Số thứ tự */}
                    <TableCell align="center" sx={[Style.MuiTableCellRootTd]} className="border">
                      {row.stt}
                    </TableCell>
                    {/* Công đoạn */}
                    <TableCell align="left" sx={[Style.MuiTableCellRootTd]} className="border whitespace-nowrap">
                      {row.stepCode}
                    </TableCell>
                    {/* Người XNHT */}
                    <TableCell align="left" sx={[Style.MuiTableCellRootTd]} className="border">
                      {row.xnhtBy}
                    </TableCell>
                    {/* Thời gian XNHT */}
                    <TableCell align="center" sx={[Style.MuiTableCellRootTd]} className="border">
                      {row.xnhtTime ? moment(row.xnhtTime).format('DD/MM/YYYY HH:mm:ss') : ''}
                    </TableCell>
                    {/* Người hủy */}
                    <TableCell align="left" sx={[Style.MuiTableCellRootTd]} className="border">
                      {row.cancelXNHTBy ?? ''}
                    </TableCell>
                    {/* Thời gian hủy XNHT */}
                    <TableCell align="center" sx={[Style.MuiTableCellRootTd]} className="border">
                      {row.cancelXNHTTime ? moment(row.cancelXNHTTime).format('DD/MM/YYYY HH:mm:ss') : ''}
                    </TableCell>
                    {/* Hủy XNHT */}
                    <TableCell align="left" sx={[Style.MuiTableCellRootTd]} className="border">
                      {row.status === 'CHUAHOANTHANH' ? (
                        <div className="flex justify-center">
                          <span>Chưa xác nhận hoàn thành</span>
                        </div>
                      ) : (
                        <div className="flex justify-center">
                          {/* kiểm tra phân quyền */}
                          {props.editLSX ? (
                            <button
                              disabled={isDisable[index]}
                              className="whitespace-nowrap text-default text-white bg-primary px-2.5 py-0.25 rounded-base border-gray-300 border flex gap-1 items-center justify-center"
                              onClick={() => {
                                handleOpen(row.stt);
                              }}
                            >
                              <Close className="!text-sm font-bold" /> Hủy
                            </button>
                          ) : (
                            ''
                          )}
                        </div>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>

      {/* pop up */}

      <div>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={() => handleClose('ignore')}
          aria-labelledby="responsive-dialog-title"
          classes={{
            paper: '!max-w-2xl',
          }}
        >
          <DialogTitle id="responsive-dialog-title">{'Xác nhận hủy XNHT'}</DialogTitle>
          <DialogContent>
            {/* DialogContentText mặc định tạo ra thẻ <p> nên phải thêm component="div" để tránh 2 thẻ <p> lòng nhau*/}
            <DialogContentText component="div">
              <Typography textAlign={'left'} whiteSpace={'nowrap'}>
                {'Bạn có chắc muốn thực hiện thao tác này ?'}
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              size="small"
              variant="outlined"
              onClick={() => {
                handleClose('ignore');
              }}
            >
              Đóng
            </Button>
            <Button
              size="small"
              variant="contained"
              onClick={() => {
                handleClose('confirm');
              }}
              autoFocus
            >
              Xác Nhận
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}

export default HistoryConfirmStage;
